import { type CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { type RowInformation } from '../../../../config/flavourConfig';
import { Table, Box } from '@flos/react-ui';
import TableRow from '../../../../shared_components/TableRow/TableRow';
import { getInsuranceSumsShoppingBasketConfig } from '../../utils/ShoppingBasketInsuranceSumsUtil';
import { useHippoText } from '../../../../hooks/useHippoText';
import { useState } from 'react';
import CallMeModal from '../../../../shared_components/CallMeModal/CallMeModal';

const ShoppingBasketInsuranceSums = ({
    coverable
}: {
    coverable: CoverableDTO;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const [showCallMeModal, setShowCallMeModal] = useState<boolean>(false);

    const componentProperties = getInsuranceSumsShoppingBasketConfig(coverable);
    const coverableProperties = componentProperties?.rowsInformation.filter(
        (rowInfo) => !rowInfo.hidden
    );
    if (!coverableProperties) {
        return <></>;
    }

    return (
        <>
            <Box className="u-border-none u-shadow-none">
                <div className="u-flex-box u-flex-box--center u-flex-box--space-between u-flex-box--nowrap u-spacing-stack-m">
                    <div className="u-flex-box u-flex-box--space-between">
                        <h4>{getHippoText('DSS-SHOPPING-BASKET-INSURANCE-SUMS-TITLE')}</h4>
                    </div>
                </div>
                <Table mobileDirection="vertical">
                    <Table.Body>
                        {coverableProperties?.map((rowInfo: RowInformation) => {
                            return (
                                <TableRow
                                    rowInfo={rowInfo}
                                    key={rowInfo.name}
                                    shouldAlignTextLeftOnMobile
                                />
                            );
                        })}
                    </Table.Body>
                </Table>
            </Box>
            {showCallMeModal && (
                <CallMeModal
                    activityCode="dss_call_request"
                    showModal={showCallMeModal}
                    closeModal={() => {
                        setShowCallMeModal(false);
                    }}
                />
            )}
        </>
    );
};

export default ShoppingBasketInsuranceSums;
